import { Fragment } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Services from "../../api/service";
import DreamSection from "./DreamSection";
import ServiceFaq from "./ServiceFaq";
import vImg from "../../images/service-single/wpo-video.jpg";
import Footer from "../../components/footer/Footer";
import VideoModal from "../../components/ModalVideo/VideoModal";

interface ServiceItem {
  id: string;
  title: string;
  slug: string;
  ssImg: string;
  [key: string]: any;
}

const ServiceSinglePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const serviceDetails: ServiceItem | undefined = Services.find(
    (item) => item.slug === slug
  );

  if (!serviceDetails) {
    return (
      <Fragment>
        <Navbar hclass="wpo-header-style-1" />
        <PageTitle pageTitle="Service Not Found" pagesub="Error" />
        <div className="container text-center py-100">
          <h2>Oops! Service not found.</h2>
          <p>The service you are looking for does not exist or has been removed.</p>
        </div>
        <Footer footerClass="wpo-site-footer-s1" />
        <Scrollbar />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle={serviceDetails.title} pagesub="Service" />

      <section className="service-single-page">
        <div className="container-fluid">
          <div className="service-image">
            <img src={serviceDetails.ssImg} alt={serviceDetails.title} />
          </div>

          <div className="row align-items-center">
            <div className="col-lg-8 col-12">
              <div className="content">
                <h2 className="poort-text poort-in-right">
                  What’s Included In The Wedding Service
                </h2>
                <p>
                  <span>M</span>odern Weddings are a beautiful reflection of love
                  and celebration, timeless in their essence. For centuries,
                  wedding traditions have brought people together, weaving
                  unforgettable moments of joy, unity, and beauty. From ancient
                  rituals to contemporary celebrations, the heart of a wedding
                  remains the same—a sacred promise of love and togetherness that
                  stands the test of time.
                </p>
                <p>
                  Two hearts unite as one, and sacred vows fill the day with joy
                  and beauty. From blooming flowers to radiant smiles, every
                  detail creates memories to treasure forever. Gentle laughter and
                  tender glances weave together in a celebration of love and
                  togetherness. A wedding is more than a single day—it is the
                  beginning of a lifelong journey shared in love and happiness.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-12">
              <div
                className="video"
                style={{
                  background: `url(${vImg}) no-repeat center center`,
                  backgroundSize: "cover",
                }}
              >
                <div className="video-holder">
                  <VideoModal />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DreamSection />
      <ServiceFaq />
      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceSinglePage;
